export const PAGE_CONFIG = {
  title: 'Monthly-excl.smurf',
  titleCN: '月报-去小号',
  subTitle: '',
  subTitleCN: '',
  path: '/overview/xh-monthly',
  defaultTab: 'overall',
  tabList: [
    {
      id: 'overall',
      tabName: 'Overall',
      tabNameCN: '总览',
      isHaveNotification: true,
      notificationPath: '/overview/xh-monthly',
      path: '/overview/xh-monthly',
      tabIcon: '',
      logConfig: {
        pageId: '203901',
        pageName: 'overviewMonthlyXh',
        extInfo: 'overviewMonthlyXh',
        pagePath: '/overview/xh-monthly',
      },
      filters: [
        {
          name: 'MonthlyXhFilterCo',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/overview/xh-monthly',
          componentList: [{
            name: 'KeyMetricTitle',
            className: '',
            type: 'view',
            style: {},
            props: {}
          },
          {
            name: 'MobileKeyMetricsCo',
            className: 'dbd-mobile-card dbd-daily-card',
            type: 'view',
            style: {},
            props: {
              config: {
                api: '/api/v1/dashboard/overview_month/xh/key_performance_metrics',
                trendApi: '/api/v1/dashboard/overview_month/xh/metrics_trend',
                isMoblie: true,
                isDark: true,
                haveJump: true,
                mainMetricsList: ["MAU", "Revenue", "New", "M2(T-1)", "ARPU", "Payer%", "mau", "revenue", "new", "m2", "arpu", "payer_ratio"],
                metricsList: ["mau", "revenue", "new", "m2", "arpu", "payer_ratio"],
              }
            },
            children: [
              {
                name: 'CommonRow',
                className: '',
                type: 'layout',
                style: {},
                props: {},
                children: [
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/engagement/active',
                            componentMetrics: [{
                              metricKey: 'MAU',
                              trendKey: 'mau',
                              enName: 'MAU',
                              cnName: '月活跃',
                              rangeEnName: 'Avg.MAU',
                              rangeCnName: '月平均活跃',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'int',
                              decimal: 0,
                              icon: 'user-u',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/monetization/revenue',
                            componentMetrics: [{
                              metricKey: 'Revenue',
                              trendKey: 'revenue',
                              enName: 'Revenue($)',
                              cnName: '付费金额($)',
                              rangeEnName: 'Revenue($)',
                              rangeCnName: '付费金额($)',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'decimals',
                              decimal: 2,
                              icon: 'dollar',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/engagement/register',
                            componentMetrics: [{
                              metricKey: 'New',
                              trendKey: 'new',
                              enName: 'New',
                              cnName: '新进用户',
                              rangeEnName: 'New',
                              rangeCnName: '新进用户',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'int',
                              decimal: 0,
                              icon: 'user-plus',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                ],
              },
              {
                name: 'CommonRow',
                className: '',
                type: 'layout',
                style: {},
                props: {},
                children: [
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/retention/index',
                            componentMetrics: [{
                              metricKey: 'M2(T-1)',
                              trendKey: 'm2',
                              enName: 'M2(T-1)',
                              cnName: '次月留存(T-1)',
                              rangeEnName: 'M2(T-1)',
                              rangeCnName: '次月留存(T-1)',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'percent',
                              decimal: 2,
                              icon: 'user-success',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/monetization/revenue',
                            componentMetrics: [{
                              metricKey: 'ARPU',
                              trendKey: 'arpu',
                              enName: 'ARPU($)',
                              cnName: '活跃ARPU($)',
                              rangeEnName: 'ARPU($)',
                              rangeCnName: '活跃ARPU($)',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'decimals',
                              decimal: 2,
                              icon: 'user-dollar',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 8 },
                    children: [
                      {
                        name: 'MetricCard',
                        className: '',
                        style: {},
                        type: 'view',
                        props: {
                          config: {
                            jumpUrl: '/monetization/revenue',
                            componentMetrics: [{
                              metricKey: 'Payer%',
                              trendKey: 'payer_ratio',
                              enName: 'Payer%',
                              cnName: '付费渗透率',
                              rangeEnName: 'Payer%',
                              rangeCnName: '付费渗透率',
                              preUnit: '',
                              endUnit: '',
                              rainbowKey: '',
                              type: 'percent',
                              decimal: 2,
                              icon: 'pie-chart-icon',
                              position: '',
                            }]
                          }
                        },
                        children: []
                      },
                    ]
                  },
                ],
              },
            ]
          },
          {
            name: 'EventService',
            className: '',
            type: 'view',
            style: { marginTop: '10px' },
            props: {},
            children: [
              {
                name: 'CommonRow',
                className: '',
                type: 'layout',
                style: {},
                props: {},
                children: [
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 12 },
                    children: [
                      {
                        name: 'OverviewMetricsTrendCo',
                        className: '',
                        type: 'view',
                        style: {},
                        props: {
                          config: {
                            renderIndex: 0,
                            isMoblie: true,
                            api: {
                              metricsApi: '/api/v1/dashboard/overview_month/xh/metrics_trend',
                              dimensionApi: '/api/v1/dashboard/overview_month/xh/dimension/metrics_trend',
                            },
                            componentMetrics: [
                              { enName: 'MAU', cnName: '月活跃', metricKey: 'mau', type: 'int', decimal: 0 },
                              { enName: 'New', cnName: '新进用户', metricKey: 'new', type: 'int', decimal: 0 },
                              { enName: 'M2', cnName: '次月留存', metricKey: 'm2', type: 'percent', decimal: 2 },
                              { enName: 'M3', cnName: '3月留存', metricKey: 'm3', type: 'percent', decimal: 2 },
                              { enName: 'TNU', cnName: '总注册用户数', metricKey: 'tru', type: 'int', decimal: 0 },
                              { enName: 'PCU', cnName: '最高同时在线', metricKey: 'pcu', type: 'int', decimal: 0 },
                              { enName: 'ACU', cnName: '平均同时在线', metricKey: 'acu', type: 'int', decimal: 0 },
                              { enName: 'Avg.Playtime(min)', cnName: '平均在线时长(分钟)', metricKey: 'aot', type: 'decimals', decimal: 2 },
                              { enName: 'WM2', cnName: '加权次月留存', metricKey: 'weighted_m2', type: 'percent', decimal: 2 },
                              { enName: 'WM3', cnName: '加权3月留存', metricKey: 'weighted_m3', type: 'percent', decimal: 2 },
                              { enName: 'Avg.DAU', cnName: '月平均DAU', metricKey: 'avg.mau', type: 'int', decimal: 0 },
                            ]
                          }
                        }
                      },
                    ]
                  },
                  {
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: { w: 12 },
                    children: [
                      {
                        name: 'OverviewMetricsTrendCo',
                        className: '',
                        type: 'view',
                        style: {},
                        props: {
                          config: {
                            renderIndex: 1,
                            isMoblie: true,
                            api: {
                              metricsApi: '/api/v1/dashboard/overview_month/xh/metrics_trend',
                              dimensionApi: '/api/v1/dashboard/overview_month/xh/dimension/metrics_trend',
                            },
                            componentMetrics: [
                              { enName: 'Revenue($)', cnName: '付费金额($)', metricKey: 'revenue', type: 'decimals', decimal: 2 },
                              { enName: 'ARPPU($)', cnName: '付费ARPPU($)', metricKey: 'arppu', type: 'decimals', decimal: 2 },
                              { enName: 'ARPU($)', cnName: '活跃ARPU($)', metricKey: 'arpu', type: 'decimals', decimal: 2 },
                              { enName: 'Payer', cnName: '付费人数', metricKey: 'payer', type: 'int', decimal: 0 },
                              { enName: 'Payer%', cnName: '付费渗透率', metricKey: 'payer_ratio', type: 'percent', decimal: 2 },
                            ]
                          }
                        }
                      },
                    ]
                  }
                ],
              },
            ]
          },
          {
            name: 'OverviewTableCo',
            className: '',
            type: 'view',
            style: { marginTop: '20px' },
            props: {
              config: {
                api: {
                  tableApi: '/api/v1/dashboard/overview_month/xh/overall_performance',
                  tableDownloadApi: '/api/v1/dashboard/overview_month/xh/performance/download',
                },
                tableConfig: {
                  hideExplain: true
                },
                componentMetrics: [
                  {
                    metricKey: 'total_users',
                    reqMetricKey: 'total_users',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 110,
                    cnWidth: 130,
                    enName: 'TNU',
                    cnName: '总注册用户数',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'new_users',
                    reqMetricKey: 'new_users',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 110,
                    cnWidth: 110,
                    enName: 'New',
                    cnName: '新进用户',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'avg_new_users',
                    reqMetricKey: 'avg_new_users',
                    enPercentWidth: 140,
                    cnPercentWidth: 160,
                    enWidth: 160,
                    cnWidth: 180,
                    enName: 'Avg.Daily New',
                    cnName: '平均每日新进用户数',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },

                  {
                    metricKey: 'active_users',
                    reqMetricKey: 'active_users',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 110,
                    cnWidth: 110,
                    enName: 'MAU',
                    cnName: '月活跃',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'avg_active_users',
                    reqMetricKey: 'avg_active_users',
                    enPercentWidth: 200,
                    cnPercentWidth: 154,
                    enWidth: 170,
                    cnWidth: 170,
                    enName: 'Month Avg.DAU',
                    cnName: '月平均日活跃',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },

                  {
                    metricKey: 'pay_amount',
                    reqMetricKey: 'pay_amount',
                    enPercentWidth: 190,
                    cnPercentWidth: 190,
                    enWidth: 155,
                    cnWidth: 130,
                    enName: 'Revenue($)',
                    cnName: '付费金额($)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },

                  {
                    metricKey: 'avg_pay_amount',
                    reqMetricKey: 'avg_pay_amount',
                    enPercentWidth: 230,
                    cnPercentWidth: 160,
                    enWidth: 230,
                    cnWidth: 160,
                    enName: 'Month Avg.Revenue($)',
                    cnName: '月均付费金额($)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },

                  {
                    metricKey: 'pcu',
                    reqMetricKey: 'pcu',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 85,
                    cnWidth: 122,
                    enName: 'PCU',
                    cnName: '最高同时在线',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'acu',
                    reqMetricKey: 'acu',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 85,
                    cnWidth: 122,
                    enName: 'ACU',
                    cnName: '平均同时在线',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'aot',
                    reqMetricKey: 'aot',
                    enPercentWidth: 180,
                    cnPercentWidth: 180,
                    enWidth: 166,
                    cnWidth: 190,
                    enName: 'Avg.Playtime(min)',
                    cnName: '平均在线时长(分钟)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'm2',
                    reqMetricKey: 'm2',
                    enPercentWidth: 145,
                    cnPercentWidth: 145,
                    enWidth: 145,
                    cnWidth: 145,
                    enName: 'M2',
                    cnName: '次月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 2,
                  },
                  {
                    metricKey: 'm3',
                    reqMetricKey: 'm3',
                    enPercentWidth: 145,
                    cnPercentWidth: 145,
                    enWidth: 145,
                    cnWidth: 145,
                    enName: 'M3',
                    cnName: '3月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 2,
                  },
                  {
                    metricKey: 'm4',
                    reqMetricKey: 'm4',
                    enPercentWidth: 145,
                    cnPercentWidth: 145,
                    enWidth: 145,
                    cnWidth: 145,
                    enName: 'M4',
                    cnName: '4月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 2,
                  },


                  {
                    metricKey: 'paid_users',
                    reqMetricKey: 'paid_users',
                    enPercentWidth: 140,
                    cnPercentWidth: 140,
                    enWidth: 100,
                    cnWidth: 100,
                    enName: 'Payer',
                    cnName: '付费人数',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },

                  {
                    metricKey: 'payer_rate',
                    reqMetricKey: 'payer_rate',
                    enPercentWidth: 130,
                    cnPercentWidth: 130,
                    enWidth: 130,
                    cnWidth: 130,
                    enName: 'Payer%',
                    cnName: '付费渗透率',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 1,
                  },
                  {
                    metricKey: 'arpu',
                    reqMetricKey: 'arpu',
                    enPercentWidth: 190,
                    cnPercentWidth: 190,
                    enWidth: 115,
                    cnWidth: 120,
                    enName: 'ARPU($)',
                    cnName: '活跃ARPU($)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },
                  {
                    metricKey: 'arppu',
                    reqMetricKey: 'arppu',
                    enPercentWidth: 190,
                    cnPercentWidth: 190,
                    enWidth: 115,
                    cnWidth: 150,
                    enName: 'ARPPU($)',
                    cnName: '付费ARPPU($)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },
                  {
                    metricKey: 'new_paid_users',
                    reqMetricKey: 'new_paid_users',
                    enPercentWidth: 200,
                    cnPercentWidth: 200,
                    enWidth: 200,
                    cnWidth: 140,
                    enName: 'First-time Payer',
                    cnName: '首次付费用户',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },

                  {
                    metricKey: 'new_pay_amount',
                    reqMetricKey: 'new_pay_amount',
                    enPercentWidth: 260,
                    cnPercentWidth: 210,
                    enWidth: 260,
                    cnWidth: 205,
                    enName: 'Revenue(first-time payer)',
                    cnName: '首次付费用户金额',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },

                  {
                    metricKey: 'new_arppu',
                    reqMetricKey: 'new_arppu',
                    enPercentWidth: 230,
                    cnPercentWidth: 190,
                    enWidth: 230,
                    cnWidth: 190,
                    enName: 'First-time Payer ARPPU($)',
                    cnName: '首次付费用户ARPPU($)',
                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1,
                  },
                  {
                    metricKey: 'alc',
                    reqMetricKey: 'alc',
                    enPercentWidth: 160,
                    cnPercentWidth: 125,
                    enWidth: 160,
                    cnWidth: 125,
                    enName: 'Sessions per user',
                    cnName: '平均登录次数',

                    type: 'decimals',
                    decimal: 2,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'retention_users',
                    reqMetricKey: 'retention_users',
                    enPercentWidth: 190,
                    cnPercentWidth: 175,
                    enWidth: 190,
                    cnWidth: 175,
                    enName: 'MAU Retention Users',
                    cnName: '日活留存',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'churn_users',
                    reqMetricKey: 'churn_users',
                    enPercentWidth: 160,
                    cnPercentWidth: 160,
                    enWidth: 130,
                    cnWidth: 100,
                    enName: 'Churn Users',
                    cnName: '月流失',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'churn_rate',
                    reqMetricKey: 'churn_rate',
                    enPercentWidth: 145,
                    cnPercentWidth: 145,
                    enWidth: 80,
                    cnWidth: 86,
                    enName: 'Churn%',
                    cnName: '流失率',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'return_users',
                    reqMetricKey: 'return_users',
                    enPercentWidth: 180,
                    cnPercentWidth: 170,
                    enWidth: 165,
                    cnWidth: 95,
                    enName: 'MAU Return Users',
                    cnName: '月回流',
                    type: 'int',
                    decimal: 0,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'weighted_m2',
                    reqMetricKey: 'weighted_m2',
                    enPercentWidth: 150,
                    cnPercentWidth: 150,
                    enWidth: 170,
                    cnWidth: 160,
                    enName: 'Weighted M2',
                    cnName: '加权次月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'weighted_m3',
                    reqMetricKey: 'weighted_m3',
                    enPercentWidth: 150,
                    cnPercentWidth: 150,
                    enWidth: 170,
                    cnWidth: 160,
                    enName: 'Weighted M3',
                    cnName: '加权3月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 1
                  },
                  {
                    metricKey: 'weighted_m4',
                    reqMetricKey: 'weighted_m4',
                    enPercentWidth: 150,
                    cnPercentWidth: 150,
                    enWidth: 170,
                    cnWidth: 160,
                    enName: 'Weighted M4',
                    cnName: '加权4月留存',
                    type: 'percent',
                    decimal: 2,
                    percentDecimals: 1
                  },
                ]
              }
            }
          },
          {
            name: 'CommonRow',
            className: 'margin-t-10',
            type: 'layout',
            style: {},
            props: {},
            children: [
              {
                name: 'UserCompositionCo',
                className: '',
                type: 'view',
                props: {
                  config: {
                    api: '/api/v1/dashboard/overview_month/xh/metrics_users',
                    byType: 'country'
                  }
                },
                children: [{
                  name: 'CommonCol',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {
                    w: 12
                  },
                  children: [
                    {
                      name: 'MetricsUserCompositionCo',
                      className: '',
                      type: 'view',
                      style: {},
                      props: {
                        config: {
                          timeType: 'MONTH',
                          metricType: 'mau',
                          jumpUrl: '/engagement/active/activeUsers',
                          initChartIndex: 0,
                          "tooltipConfig": {
                            "valueNameEn": "MAU",
                            "valueNameCn": "月活跃",
                            "showWeek": false
                          },
                          showComList: ['barChart', 'lineChart', 'sheet']
                        }
                      }
                    },
                  ]
                },
                {
                  name: 'CommonCol',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: { w: 12 },
                  children: [
                    {
                      name: 'MetricsUserCompositionCo',
                      className: '',
                      type: 'view',
                      style: {},
                      props: {
                        config: {
                          timeType: 'MONTH',
                          metricType: 'channel',
                          titleEn: 'Channels of New Users',
                          titleCn: '新进用户渠道构成',
                          jumpUrl: '/engagement/register',
                          metricKey: 'channels_of_new_user_v2',
                          metricTotalKey: 'channels_of_new_user_total',
                          accumateKey: 'channel',
                          initChartIndex: 0,
                          "tooltipConfig": {
                            "valueNameEn": "New Users",
                            "valueNameCn": "新进用户",
                            "showWeek": false
                          },
                          showComList: ['barChart', 'lineChart', 'sheet']
                        }
                      }
                    },
                  ]
                }]
              }
            ],
          },
          {
            name: "CommonRow",
            className: '',
            type: "layout",
            style: {},
            props: {},
            children: [
              {
                name: "RankListTabCo",
                className: '',
                style: {},
                type: "view",
                data: {
                  regionDataType: "country",
                  tabOrder: ["country", "region", "zone", 'channel', 'os'],
                },
                children: [
                  {
                    name: 'CommonMobileDailyRankServiceCo',
                    className: '',
                    style: {},
                    type: "view",
                    props: {
                      config: {
                        api: "/api/v1/dashboard/overview_month/xh/countries_region_zone",
                      }
                    },
                    children: [
                      {
                        name: "CommonMobileDailyRankListCo",
                        className: '',
                        type: "view",
                        style: {},
                        props: {
                          config: {
                            metric: "mau",
                            componentMetrics: {
                              reqMetricKey: "active",
                              metricKey: "value",
                              enMonthTitleName: 'MAU',
                              cnMonthTitleName: '月活跃用户',
                              enMonthName: "MAU",
                              cnMonthName: "月活跃用户",
                              rangeEnMonthName: "Avg.MAU",
                              rangeCnMonthName: "月平均活跃",
                              prefix: "Avg",
                              type: "int",
                              decimal: 0,
                              percentDecimals: 0,
                              showConfig: {
                                showTable: true,
                                showChart: true,
                              }
                            },
                            initChartIndex: 3,
                            jumpUrl: '/comparisonAnalysis/countryComparison',
                            isShowMapByCountry: true,
                            comConfig: {
                              isHaveBar: true,
                              isHaveLine: true,
                              isHavePie: true,
                              isHaveShare: true
                            },
                          }
                        }
                      },
                      {
                        name: "CommonMobileDailyRankListCo",
                        className: '',
                        type: "view",
                        style: {},
                        props: {
                          config: {
                            metric: "revenue",
                            componentMetrics: {
                              reqMetricKey: "revenue",
                              metricKey: "value",
                              enMonthTitleName: 'Revenue',
                              cnMonthTitleName: '付费金额',
                              enMonthName: "Revenue($)",
                              cnMonthName: "付费金额",
                              rangeEnMonthName: "Sum Revenue($)",
                              rangeCnMonthName: "总付费金额($)",
                              prefix: "Sum",
                              type: "decimals",
                              decimal: 2,
                              percentDecimals: 1,
                              showConfig: {
                                showTable: true,
                                showChart: true,
                              }
                            },
                            initChartIndex: 0,
                            jumpUrl: '/comparisonAnalysis/countryComparison',
                            isShowMapByCountry: true,
                            comConfig: {
                              isHaveBar: true,
                              isHaveLine: true,
                              isHavePie: true,
                              isHaveShare: true
                            },
                          }
                        }
                      },
                      {
                        name: "CommonMobileDailyRankListCo",
                        className: '',
                        type: "view",
                        style: {},
                        props: {
                          config: {
                            metric: "new",
                            componentMetrics: {
                              reqMetricKey: "new",
                              metricKey: "value",
                              enMonthTitleName: 'New',
                              cnMonthTitleName: '新进用户',
                              enMonthName: "New",
                              cnMonthName: "新进",
                              rangeEnMonthName: "Avg.MAU",
                              rangeCnMonthName: "月平均活跃",
                              prefix: "Avg",
                              type: "int",
                              decimal: 0,
                              percentDecimals: 0,
                              showConfig: {
                                showTable: true,
                                showChart: true,
                              }
                            },
                            initChartIndex: 0,
                            jumpUrl: '/comparisonAnalysis/countryComparison',
                            isShowMapByCountry: true,
                            comConfig: {
                              isHaveBar: true,
                              isHaveLine: true,
                              isHavePie: true,
                              isHaveShare: true
                            },
                          }
                        }
                      },
                    ]
                  }


                ]
              },
            ],
          },
          ]
        },


      ],
    },
  ]
};